"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Calendar, MapPin } from "lucide-react";
export default function UpcomingRetreatsPrograms() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const retreats = [{
    id: 4,
    title: "Weeklong Big Springs Retreat",
    date: "May 13 - 20, 2026",
    location: "Big Springs Retreat Center, Sierra City, CA",
    thumbnail: "https://profound-pup.10web.cloud/wp-content/uploads/2025/11/Giardino-zen-13.jpg",
    link: "/retreat/winter-contemplative"
  }, {
    id: 5,
    title: "Hidden Villa Retreat",
    date: "October 25 - 29, 2026",
    location: "Hidden Villa, Los Altos Hills, CA",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/hidden_villa_retreat_october.png",
    link: "/retreat/hidden-villa"
  }, {
    id: 6,
    title: "8-Week Pāli Canon Course with Barre Center for Buddhist Studies",
    date: "October to November, 2026",
    location: "Barre Center for Buddhist Studies",
    thumbnail: "https://profound-pup.10web.cloud/wp-content/uploads/2025/11/4.-Scribe-1-scaled.jpg",
    link: "/retreat/sati-center-sutta-study"
  }, {
    id: 7,
    title: "10-day Big Springs Retreat",
    date: "May 20 - 30, 2027",
    location: "Big Springs Retreat Center, Sierra City, CA",
    thumbnail: "https://profound-pup.10web.cloud/wp-content/uploads/2025/11/Giardino-zen-13.jpg",
    link: "https://www.insightretreatcenter.org/offsite-retreats/"
  }];
  return <section className="bg-primary-light py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div ref={ref} className={`mb-12 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl font-display font-bold text-foreground mb-3">
            Upcoming Retreats & Programs
          </h2>
          <p className="text-muted-foreground text-lg">
            Join us to enrich and deepen the practice
          </p>
        </div>

        <div className="space-y-6">
          {retreats.map((retreat, i) => <Card key={retreat.id} data-index={i} className="group relative overflow-hidden transition-all duration-300 hover:shadow-strong cursor-pointer border border-border">
              <div className="flex flex-col sm:flex-row items-stretch">
                <div className="relative w-full sm:w-48 h-48 sm:h-auto overflow-hidden flex-shrink-0">
                  <img src={retreat.thumbnail} alt={retreat.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:translate-y-[-4px] group-hover:scale-105" loading="lazy" decoding="async" />
                  
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary transition-all duration-300 group-hover:w-1.5 group-hover:shadow-[0_0_12px_rgba(140,180,135,0.6)]" style={{
                clipPath: "polygon(0 0, 100% 5%, 100% 95%, 0 100%)"
              }} />
                </div>

                <div className="flex-1 p-6 flex flex-col justify-center relative">
                  <h3 className="text-2xl font-display font-semibold text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
                    {retreat.title}
                  </h3>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center gap-2 text-muted-foreground">
                      <SafeHydrate><Calendar className="size-4 text-primary" /></SafeHydrate>
                      <span className="text-sm">{retreat.date}</span>
                    </div>
                    <div className="flex items-center gap-2 text-muted-foreground">
                      <MapPin className="size-4 text-secondary" />
                      <span className="text-sm">{retreat.location}</span>
                    </div>
                  </div>

                  <div className="absolute right-6 bottom-6 opacity-0 translate-x-8 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                    <Link to={i === 0 ? "https://www.insightretreatcenter.org/offsite-retreats/" : i === 1 ? "https://www.insightretreatcenter.org/hidden-villa/" : i === 2 ? "https://www.buddhistinquiry.org" : i === 3 ? "https://www.insightretreatcenter.org/offsite-retreats/" : retreat.link} newTab={i === 0 || i === 1 || i === 2 || i === 3}>
                      <Button variant="default" size="sm" className="shadow-medium">
                        Register
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}